import { createContext, ReactNode } from 'react';

/**
 * Allows child components (InviteUsers, UserRooms) to register their pagination
 * into the shared pagination slot rendered in InvitePlayersPage.
 * The setter is stable (React useState dispatcher) so it is safe to use as a dep.
 */
export const PaginationSlotContext = createContext<
  ((node: ReactNode) => void) | null
>(null);
